import Vue from 'vue';
import App from './App.vue';
import router from "./router/index.js";
import store from "./store";
import moment from 'moment';
import DatePicker from 'vue2-datepicker';
import vSelect from 'vue-select';
import VueSweetalert2 from 'vue-sweetalert2';
import VueApexCharts from 'vue-apexcharts'
import VueGoodTable from 'vue-good-table';
import VeeValidate from 'vee-validate'
import Dropzone from 'vue2-dropzone'
// import {Chart} from 'chart.js';
// import $ from 'jquery'
// import Swal from 'sweetalert2';


import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
// import './assets/js/theme.bundle.js'
// import './assets/js/vendor.bundle.js'
// import Swal from 'sweetalert2/dist/sweetalert2.js'



import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
// import "./plugins/bootstrap-vue";
import './assets/css/libs.bundle.css'
import './assets/css/theme.bundle.css'
// FullCalendar v6 uses CSS-in-JS, no separate CSS import needed
import 'vue2-datepicker/index.css';
import 'vue-select/dist/vue-select.css';
import 'sweetalert2/dist/sweetalert2.min.css';
import 'vue-good-table/dist/vue-good-table.css'

// import 'sweetalert2/dist/sweetalert2.min.css';
// import 'sweetalert2/src/sweetalert2.scss'


// import Swal from 'sweetalert2/dist/sweetalert2.js'
// import 'bootstrap/dist/js/bootstrap.esm.min.js'

// import VueSweetalert2 from 'vue-sweetalert2';

// import 'bootstrap/dist/js/bootstrap.js'


window.axios = require("axios");
window.queryString = require("query-string");
// window.axios.defaults.baseURL = "";

Vue.prototype.$moment = moment



Vue.config.productionTip = false
Vue.component('v-select', vSelect)
Vue.component('v-dropzone', Dropzone)
Vue.component('v-date-picker', DatePicker)
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(VueSweetalert2)
Vue.use(VueApexCharts)
Vue.use(VueGoodTable)
Vue.use(VeeValidate)
// Vue.use(Chart)
// Vue.use($)

Vue.component('apexchart', VueApexCharts)

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
